var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGroupSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.3,
    height: 23.7,
    viewBox: "0 0 23.3 23.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-group-search"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,9.1a2.7,2.7,0,1,1,2.7,2.7A2.69,2.69,0,0,1,9.6,9.1Zm.7,0a2,2,0,1,0,2-2A2.07,2.07,0,0,0,10.3,9.1Z",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,16.1c0-1.6-1.6-2.9-3.7-2.9s-3.7,1.3-3.7,2.9a.4.4,0,0,1-.8,0c0-2,2-3.6,4.4-3.6s4.4,1.6,4.4,3.6a.43.43,0,0,1-.4.4A.7.7,0,0,1,16,16.1Z",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.4,12.1a7.7,7.7,0,1,1,7.7,7.7A7.7,7.7,0,0,1,4.4,12.1Zm1.2,0a6.6,6.6,0,1,0,6.6-6.6A6.66,6.66,0,0,0,5.6,12.1Z",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,20.4l-1.5-1.5a.57.57,0,0,1,.8-.8l1.5,1.5a.61.61,0,0,1,0,.8.76.76,0,0,1-.4.2A.52.52,0,0,1,19.7,20.4Z",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.6,5.2a2.26,2.26,0,0,1-2.3-2.3,2.3,2.3,0,1,1,4.6,0A2.26,2.26,0,0,1,19.6,5.2Zm0-4.1a1.75,1.75,0,0,0-1.7,1.7,1.7,1.7,0,1,0,3.4,0A1.75,1.75,0,0,0,19.6,1.1Z",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,10.84a.27.27,0,0,1-.3-.3c0-1.4-1.4-2.5-3.2-2.5a3.08,3.08,0,0,0-1,.1c-.2,0-.3,0-.4-.2s0-.3.2-.4a5,5,0,0,1,1.2-.2c2.1,0,3.8,1.4,3.8,3.1C23.4,10.74,23.2,10.84,23.1,10.84Z",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.9,17.4a2.33,2.33,0,0,1,2.3-2.3,2.3,2.3,0,0,1,0,4.6A2.33,2.33,0,0,1,1.9,17.4Zm.6,0a1.75,1.75,0,0,0,1.7,1.7,1.7,1.7,0,1,0,0-3.4A1.75,1.75,0,0,0,2.5,17.4Z",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9,23.4c0-1.2-1.3-2.1-2.8-2.1s-2.8,1-2.8,2.1a.32.32,0,0,1-.3.3.27.27,0,0,1-.3-.3c0-1.5,1.5-2.7,3.4-2.7s3.4,1.2,3.4,2.7a.3.3,0,0,1-.6,0Z",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-0.4 -0.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-0.4 -0.3)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupSearch2);
export default __webpack_public_path__ + "static/media/user-group-search2.349568228780507541a66711f444e1b5.svg";
export { ForwardRef as ReactComponent };